import { isOpen } from "@blueprintjs/core/lib/esm/components/context-menu/contextMenu"
import { atom } from "recoil"
import { duplicateEntryTypes, uploadErrStatus } from "../../constants"
import { fetchApiKey } from "./selectors"
export const advancedModeState = atom({ key: "advanceMode", default: false })
export const apiKeyState = atom({ key: "apiKeyState", default: null })
export const userDetailState = atom({
  key: "userDetails",
  default: { username: null, password: null }
})
export const designListState = atom({
  key: "designList",
  default: { designTree: null, selectedDesigns: [], selectedFolders: [], selectedVariations: [] }
})
export const filesClipboardState = atom({
  key: "clipboardState",
  default: {
    items: [], operation: null, type: null
  },
})
export const toastState = atom({
  key: "toastState",
  default: {
    toasts: [],
    uploadStatusToast: null
  }
})
export const dialogState = atom({
  key: "dialogState",
  default: {
    dupEntryDialog: {
      entryType: duplicateEntryTypes.FILE,
      isOpen: false,
      items: [{ filename: "Cubinia.ctf", name: "Cubinia" }, { filename: "Nemoxas.ctf", name: "Nemo" }]
    },
    uploadErrDialog: {
      items: [{ filename: "Cubinia.ctf", name: "Cubinia" }, { filename: "Nemoxas.ctf", name: "Nemo" }],
      isOpen: false,
      status: uploadErrStatus.NO_INTERNET
    },
    deleteEntryDialog: {
      items: [{ filename: "Cubinia.ctf", name: "Cubinia" }, { filename: "Nemoxas.ctf", name: "Nemo" }],
      isOpen: true
    }
  }
})